import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "book, guide, info, faq" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M16.0404 10.0013V12.293C16.0404 13.2134 15.2942 13.9596 14.3737 13.9596H5.83203C4.7965 13.9596 3.95703 14.7991 3.95703 15.8346C3.95703 16.8702 4.7965 17.7096 5.83203 17.7096H8.33203M7.29036 5.83464H12.707M7.29036 9.16797H10.207M5.6237 2.29297H14.3737C15.2942 2.29297 16.0404 3.03916 16.0404 3.95964V16.043C16.0404 16.9634 15.2942 17.7096 14.3737 17.7096H5.6237C4.70322 17.7096 3.95703 16.9634 3.95703 16.043V3.95964C3.95703 3.03916 4.70322 2.29297 5.6237 2.29297Z",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }